import React, { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { uniqueId } from "lodash"

import API from "api"
// redux
import { mapDispatchProps, mapStateToProps } from "store/store"
import useInfiniteScroll from "hooks/useInfiniteScroll"
import CampaignPaymentHistoryItemV1 from "components/campaignPaymentHistoryItem/indexV1"
import { useLanguage } from "@languages/index"
import { ROUTES } from "routes"

const CampaignPaymentV1Index = (props: any) => {
  const navigate = useNavigate()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }
  const [histories, setHistories] = useState([])
  const [historiesCnt, setHistoriesCnt] = useState(0)

  const [schedule, setSchedule] = useState(undefined)
  const [isFetchFinished, setIsFetchFinished] = useState(false)
  const [isContentEnded, setIsContentEnded] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const isFetchingRef = React.useRef(false);
  const lastPageRef =React.useRef(1);
  const currentPageRef = React.useRef(1);

  const isMaster = useMemo(() => {
    return props.auth?.isMaster ?? false
  }, [props.auth?.isMaster])

  const [isFetching, setIsFetching] = useInfiniteScroll(async () => {
    if (currentPageRef.current >= lastPageRef.current) {
      return;
    }
    await fetchPaymentHistories({refresh: false, targetPage: currentPageRef.current + 1})
  })

  useEffect(() => {
    fetchPaymentHistories({refresh: true, targetPage: 1})
  }, [])

  const fetchPaymentHistories = async ({refresh = false, targetPage = 1}) => {
    if (isContentEnded && !refresh) {
      return false
    }
    if (isFetching || isFetchingRef.current) {
      return false
    }
    isFetchingRef.current = true;

    targetPage = refresh ? 1 : targetPage

    await API.CampaignPayments.index({
      ...{
        brandToken: props.auth.token,
        page: targetPage,
      },
    })
      .then((response) => {
        const fetchedHistories = response.data.histories.data

        setHistories((prevHistories) => targetPage === 1 ? fetchedHistories : prevHistories.concat(fetchedHistories))

        setHistoriesCnt(response.data.count)
        setSchedule(response.data.schedule)

        setCurrentPage(targetPage + 1)
        setIsFetchFinished(true)

        if (response.data.histories.currentPage == response.data.histories.lastPage) {
          setIsContentEnded(true)
        }
        currentPageRef.current = response.data.histories.currentPage;
        lastPageRef.current = response.data.histories.lastPage;
        isFetchingRef.current = false
        setIsFetching(false)
      })
      .catch((error) => {
        props.showModal({ text: error.message })
        isFetchingRef.current = false
        setIsFetching(false)
      })
  }

  const renderPageTitle = () => {
    return (
      <div className="flex flex-row justify-between mt-12 mb-2 lg:mb-9">
        <span className="font-bold text-2xl tracking-tighter">{languageTexts.payment_history2}</span>
        {/* <span
          className="text-sm tracking-tighter underline cursor-pointer"
          onClick={() => {

          }}
        >
          화이트라벨 이용료
        </span> */}
        {isMaster && (
          <button className="text-[14px] underline"
            onClick={() => navigate(ROUTES.CAMPAIGN_PAYMENTS_INDEX.PATH)}>
            {`캠페인별로 보기`}
          </button>
        )}
      </div>
    )
  }

  const renderHistories = () => {
    if (isFetchFinished && histories.length == 0) {
      return (
        <div className="py-10 flex flex-col justify-center w-full items-center">
          <div className="mx-5 flex">
            <span className="prose prose-xl text-slate-500">{languageTexts.payments_text_1}</span>
          </div>
        </div>
      )
    }

    return (
      <div className="flex flex-col py-10">
        {props.brand.activeSeedingPassStartedAt && props.brand.isSeedingPassAutoPurchaseEnabled ? (
          <div className="flex flex-col gap-2 pb-[28px] text-[13px]">
            <div>
              {languageTexts._payments_text_2(
                props.brand.activeSeedingPassStartedAt,
                props.settings.durationSeedingPass
              )}
            </div>
            <div>{languageTexts.payments_text_4}</div>
          </div>
        ) : null}

        <div className="flex flex-row py-2 px-5 bg-black justify-around font-bold text-white gap-3">
          <span className="w-[80px] text-start text-sm font-bold">{languageTexts.payments_text_3}</span>
          <span className="flex-1 text-right text-sm font-bold">{languageTexts.payment_info}</span>
        </div>

        {histories.map((history) => { 
          return (
            <CampaignPaymentHistoryItemV1
              key={`campaignPayment${uniqueId()}`}
              history={history}
              style={{
                fontSize: "12px",
              }}
            />
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className="xl:px-10 px-5 pb-10 mx-auto w-full max-w-[800px] mb-[48px]">
        {renderPageTitle()}
        {renderHistories()}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignPaymentV1Index)
